<template>
  <div class="account-deletion-container">
    <iframe
      :src="deletionUrl"
      frameborder="0"
      class="deletion-iframe"
    ></iframe>
  </div>
</template>

<script>
export default {
  name: "AccountDeletion",
  computed: {
    deletionUrl() {
      const locale = this.$i18n.locale;
      if (locale === 'ja' || locale === 'jp') {
        return '/accountDeletionRequest_ja.html';
      }
      return '/accountDeletionRequest.html';
    }
  }
};
</script>

<style lang="scss" scoped>
.account-deletion-container {
  width: 100%;
  height: 100vh;
  overflow: hidden;
}

.deletion-iframe {
  width: 100%;
  height: 100%;
  border: none;
}
</style>
